import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import ALoader from 'views/pages/manage/common/a-loader';
import { checkDisabledSaveButton, disbledRuleSubTypeArray, newRow, ruleSubTypeValidation, ruleTypeValidation, } from './constant';
import { GridRowModes } from '@mui/x-data-grid';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { isObjEmpty } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { generateRandomId } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { ActionsCellComponent } from 'views/pages/manage/masters/studentFinancials/paymentGatewaysConfiguration/common';
import { AGridColDef } from 'views/pages/manage/common/data-grid/ADataGridColDef';
import { ReactComponent as CancelIcon } from 'assets/img/svg/RedCancel.svg';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { Box, Tooltip } from '@mui/material';
import { editCellContainerStyle } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant';
import { ReactComponent as EyeIcon } from 'assets/img/svg/eyeIcon.svg';
// import AInput from '../../common/formFeilds/customInput/AInput';
// import Logs from './Logs';
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { numberDecimalLimitRegex } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import StatusAToggleComponent from 'views/pages/manage/common/form-fields-mui/StatusAToggleComponent';
import { regex } from 'views/pages/manage/common/constant';
import MultiSelectCellComponentWithSearch from 'views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';
import moment from 'moment';
import CustomChip from 'views/pages/manage/common/customChip/CustomChip';
import { formattedPrice } from 'views/pages/manage/unAssigned/collectPayment/utils';

const ListComponent = forwardRef(({
    rows,
    loader,
    dropdowns,
    createUpdateHandler,
    deleteHandler,
    currentPage,
    setLoader,
    totalRecords,
    currentPageSize,
    searchArpuList,
    userPermissions
}, ref) => {
    const [rowModesModel, setRowModesModel] = useState({});
    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});

    const rowFormHandler = (value, key) =>{
        setRowForm((prev) => ({ ...prev, [key]: value }));
    }

    useEffect(() => {
        setRowData(rows);
    }, [rows]);

    const startEditing = (id, form) => {
        setRowModesModel((oldModel) => ({
            [id]: { mode: GridRowModes.Edit },
        }));
        setRowForm(form);
    };

    const stopEditing = () => {
        const currForm = { ...rowForm };
        setRowModesModel((oldModel) => ({
            [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
        }));
        setRowForm({});
    };

    const handleEditClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            startEditing(params?.id, params?.row);
        }
    };
    const handleDeleteClick = (params) => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            createUpdateHandler({ ...params?.row, status: "DELETED" })
        }
    }

    const handleCancelClick = async (params) => {
        if (params?.row?.isNew) {
            setRowData(rows);
            setRowForm({});
        } else {
            stopEditing(params?.id);
        }
    };

    const handleSaveClick = async (params) => {
        createUpdateHandler(rowForm);
    };

    const addNewRow = async () => {
        if (!isObjEmpty(rowForm)) {
            failureToast(saveOrDeleteMsg);
        } else {
            let emptyRow = {
                ...newRow,
                isNew: true,
                id: generateRandomId(),
            };
             let randomId = emptyRow?.id;
            startEditing(randomId, emptyRow);
            setRowData((prev) => [emptyRow, ...prev]);
        }
    };

    useImperativeHandle(ref, () => ({
        addNewRow: addNewRow,
        startEditing: startEditing,
        stopEditing: stopEditing,
    }));

    const columns = [
        new AGridColDef("applicableComponents", "Desc",false)
            .setMinWidth(260)
            .editable(true)
            .setFlex(2.6)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}><MultiSelectCellComponentWithSearch
                            title={"Desc"}
                            data={params?.value}
                            eyeIcon
                        /></div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.applicableComponents}
                        handleChange={value => {
                            rowFormHandler(value, 'applicableComponents');
                            rowFormHandler('', 'weekBucket');
                            rowFormHandler('', 'ruleType');
                            rowFormHandler('', 'ruleSubType');                           
                            rowFormHandler('', 'maxDaysApplicable');
                            rowFormHandler('', "ruleValue")
                        }}
                        items={dropdowns?.applicableComponents}
                        isMulti={true}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                        isShowCount={true}
                    />
                </div>
            )),
        new AGridColDef("weekBucket", "Week", false)
            .setMinWidth(120)
            .editable(true)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value?.label}>
                    <div className={`ellipsis-text-container cursor`}>
                        {params.value?.label}
                    </div>
                </Tooltip> : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.weekBucket}
                        handleChange={value => {
                            rowFormHandler(value, 'weekBucket');
                            rowFormHandler('', 'ruleType');
                            rowFormHandler('', 'ruleSubType');                           
                            rowFormHandler('', 'maxDaysApplicable');
                            rowFormHandler('', "ruleValue")
                        }}
                        items={dropdowns?.weekBucket}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                    />
                </div>
            )),
        new AGridColDef("ruleType", "Deduction type", false)
            .setMinWidth(200)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
                params?.value ? <Tooltip title={params?.value?.label}>
                    <div className={`ellipsis-text-container cursor`}>
                        {params.value?.label}
                    </div>
                </Tooltip> : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.ruleType}
                        handleChange={value => {
                            rowFormHandler(value, 'ruleType');
                            rowFormHandler('', 'ruleSubType');                           
                            rowFormHandler('', 'maxDaysApplicable');
                            rowFormHandler('', "ruleValue")
                        }}
                        items={ruleTypeValidation(rowForm?.weekBucket)}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                        isDisabled={!rowForm?.weekBucket}
                    />
                </div>
            )),
        new AGridColDef("ruleSubType", "Deduction Subtype", false)
            .setMinWidth(200)
            .editable(true)
            .setFlex(2)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AAutoComplete
                        currentValue={rowForm?.ruleSubType}
                        handleChange={value => {
                            rowFormHandler(value, 'ruleSubType');
                            rowFormHandler('', "ruleValue")
                        }}
                        items={ruleSubTypeValidation(rowForm?.ruleType)}
                        isMulti={false}
                        //   style={selectStyles}
                        placeholder={'Select'}
                        autoFocus={params?.hasFocus}
                        isDisabled={!rowForm?.ruleType || disbledRuleSubTypeArray.includes(rowForm?.ruleType?.value)}
                    />
                </div>
            )),
            new AGridColDef("maxDaysApplicable", "Max Applicable Days", true)
            .setMinWidth(120)
            .editable(true)
            .setFlex(1.2)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AInput
                        placeholder='Enter'
                        value={rowForm?.maxDaysApplicable}
                        handler={(value) => {
                            rowFormHandler(value, "maxDaysApplicable")
                        }}
                        regex={regex.numeric}
                        disabled={ rowForm?.weekBucket?.value != "WEEK5_PLUS"}
                    />
                </div>)
        ),
        new AGridColDef("ruleValue", "Value", true)
            .setMinWidth(120)
            .editable(true)
            .setFlex(1.2)
            .renderCellComponent((params) => (
                (params?.value !== null && params?.value !== undefined) ?
                    <Tooltip title={
                        params?.row?.ruleType?.value === "FIXED_DEDUCT"
                            ? `${formattedPrice(params?.value)}`
                            : `${params?.value} %`
                    }>
                        <div className={`ellipsis-text-container`}>
                            {params?.row?.ruleType?.value === "FIXED_DEDUCT"
                                ? `${formattedPrice(params?.value)}`
                                : `${params?.value} %`}
                        </div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <AInput
                        placeholder='Enter'
                        value={rowForm?.ruleValue}
                        handler={(value) => {
                            rowFormHandler(value, "ruleValue")
                        }}
                        regex={rowForm?.ruleType?.value == "FIXED_DEDUCT"
                            ? numberDecimalLimitRegex(8, 2)
                            : regex.percentage
                        }
                        disabled={!rowForm?.ruleType || rowForm?.ruleType?.value == "NON_REFUNDABLE" || (!disbledRuleSubTypeArray.includes(rowForm?.ruleType?.value)&& !rowForm?.ruleSubType)}
                    />
                </div>)),
        new AGridColDef("effectiveFrom", "Effective Date", true)
            .setMinWidth(140)
            .editable(true)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value?.label}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent(params => (
                <div style={editCellContainerStyle}>
                    <CustomDatePickerV2
                        //style={{ input: inputStyle }}
                        placeHolder="Select date"
                        value={rowForm?.effectiveFrom}
                        handler={(index, date) => {
                            rowFormHandler(date, 'effectiveFrom');
                        }}
                        isStartDate={true}
                    // minDate={moment(new Date(), "DD-MM-YYYY").subtract(1, "months")}
                    // maxDate={new moment(new Date())}
                    // disabled={action == 'new' ? false : col.disabled}
                    />
                </div>)),

        new AGridColDef("updatedOn", "Last updated on", false)
            .setMinWidth(120)
            .editable(false)
            .setFlex(1)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}>
                        <div className={`ellipsis-text-container`}>{`${moment(params?.value).format('hh:mm A')}, ${moment(params?.value).format('DD MMM YYYY')} by ${params?.row?.updatedBy}`}</div>
                    </Tooltip>
                    : <div>-</div>
            )),
        new AGridColDef("status", "Status", false)
            .setMinWidth(140)
            .editable(true)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                params?.value ?
                    <Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}><CustomChip
                                  text={params?.value}
                                  textColor={params?.value == 'ACTIVE' ? '#07794C' : '#DC2804'}
                                  bgColor={params?.value == 'ACTIVE' ? '#E6F4ED' : '#FCEEED'}
                                // style={{ fontSize: 12,fontWeight:'400px', fontFamily: 'Gilroy-SemiBold' }}
                                /></div>
                    </Tooltip>
                    : <div>-</div>
            ))
            .renderEditCellComponent((params) => (
                <StatusAToggleComponent
                    params={params}
                    //toggleStatusHandler={toggleStatusHandler}
                    rowForm={rowForm}
                    status={params.value}
                    rowFormHandler={rowFormHandler}
                />
            )),
        new AGridColDef("action", "Actions", false)
            .setMinWidth(140)
            // .editable(true)
            .setFlex(1.5)
            .renderCellComponent((params) => (
                <div className='d-flex align-items-center' style={{ gap: '15px' }}>
                    <ActionsCellComponent
                        mode={params.api.getRowMode(params?.id)}
                        handleEditClick={handleEditClick}
                        handleSaveClick={handleSaveClick}
                        handleCancelClick={handleCancelClick}
                        icon={true}
                        cancelIcon={<CancelIcon
                            className="mx-2 cursor"
                            onClick={() => handleCancelClick(params)}
                        />}
                        params={params}
                        isSaveDisabled={checkDisabledSaveButton(rowForm)}
                        editPermission={userPermissions?.includes("U")}
                        customEditIcon
                    />
                </div>
            )),

    ]

    const onChangeHandler = (page, pageSize) => {
        searchArpuList({ page: page, pageSize })
    }


    return (<>
        {loader && <ALoader position='fixed' />}
        <ADataGrid
            paginationModel={{ page: currentPage, pageSize: currentPageSize }}
            removeWrapperContainer
            rowModesModel={rowModesModel}
            rows={rowData || []}
            columns={columns}
            rowId={(row) => row?.id}
            rowHeight={50}
            // loading={loader}
            rowCount={totalRecords}
            nextButtonHandler={onChangeHandler}
            currentPage={currentPage}
            // components={{
            //     ...gridComponents,
            //     NoRowsOverlay: () => (
            //         <NoRowOverlay message={loader ? "Loading..." : null} />
            //     ),
            // }}
            sx={gridStyles}
            autoHeight
        // pinLastColumn
        />
        {/* <ConfirmDeletionDialog
         handleClose
        /> */}

    </>
    );
})

export default ListComponent